module.exports = __webpack_public_path__ + "img/bg_title.b12902ef.png";